module.exports = __webpack_public_path__ + "assets/media/favicon228.7d46640240455c0cc16d106d1dbc55f6.png";